/* The app's ONE off-screen FOCUSABLE control — the native radio behind a styled row, a tile or a
 * cover, doing the work the browser does better than any re-implementation: roving focus, the
 * arrow keys, `:checked`, and the correct announcement.
 *
 * ── Why it is not `visuallyHidden.module.css` ────────────────────────────────────────────────
 * That one is `position: fixed`, deliberately: an absolutely positioned box with no positioned
 * ancestor contributes to the DOCUMENT's scrollable overflow, which cost a page-level scrollbar on
 * the client detail. A FOCUSABLE control cannot take that treatment — the browser scrolls a focused
 * element into view and one pinned to the viewport's corner has nowhere to be scrolled to, so the
 * page jumps to the top the moment an arrow key moves the selection. `absolute` against the label
 * it sits in is the right answer for exactly this case, and `visuallyHidden`'s own header says so.
 *
 * ── Why it is shared ─────────────────────────────────────────────────────────────────────────
 * The two plan dialogs had it byte-identical — „Przypisz plan"'s two picker lists and „Nowy
 * program"'s category tiles and cover pool — which is the second occurrence the styling rules take
 * as the trigger.
 *
 * The surface supplies the POSITIONED ANCESTOR and the focus ring drawn on it, because only the
 * surface knows which element is the visible control. */

.control {
  position: absolute;
  width: var(--space-1px);
  height: var(--space-1px);
  overflow: hidden;
  clip-path: inset(50%);
}
